import { HStack, Switch, Text, useColorModeValue } from '@chakra-ui/react';
import type { CollaboratorToggleProps } from '../dashboard.types';

/**
 * Collaborator Toggle Component
 * Toggles between "My Rocks" and "Collaborating On"
 */
export function CollaboratorToggle({
  value,
  onChange,
  disabled,
}: CollaboratorToggleProps) {
  const activeColor = useColorModeValue('gray.900', 'white');
  const inactiveColor = useColorModeValue('gray.500', 'gray.500');

  return (
    <HStack
      spacing={3}
      px={4}
      py={2}
      bg={useColorModeValue('white', 'gray.700')}
      rounded="lg"
      borderWidth="1px"
      borderColor={useColorModeValue('gray.300', 'gray.600')}
    >
      <Text
        fontSize="sm"
        fontWeight="medium"
        color={!value ? activeColor : inactiveColor}
        transition="color 0.2s"
      >
        My Rocks
      </Text>
      <Switch
        isChecked={value}
        onChange={(e) => onChange(e.target.checked)}
        isDisabled={disabled}
        colorScheme="blue"
        size="md"
      />
      <Text
        fontSize="sm"
        fontWeight="medium"
        color={value ? activeColor : inactiveColor}
        transition="color 0.2s"
      >
        Collaborating On
      </Text>
    </HStack>
  );
}

